(function() {
  var isMobile = window.innerWidth < 768;
  var heroMedia = null;
  var items = [];

  function collect() {
    heroMedia = document.querySelector('.hero__media');
    items = Array.from(document.querySelectorAll('.card .media img, .card__media img, img.product-media__image'));
    items.forEach(function(img) {
      img.style.transition = 'none';
      img.style.willChange = 'transform';
    });
  }

  function loop() {
    var scrollY = window.scrollY;
    if (heroMedia) {
      heroMedia.style.transform = 'translateY(' + (scrollY * 0.3) + 'px)';
    }
    items.forEach(function(img) {
      var rect = img.getBoundingClientRect();
      if (rect.bottom < -400 || rect.top > window.innerHeight + 400) return;
      var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * 0.4;
      img.style.transform = 'translateY(' + offset + 'px)';
    });
    requestAnimationFrame(loop);
  }

  document.addEventListener('DOMContentLoaded', function() {
    collect();
    loop();
    window.addEventListener('load', collect);
  });
})();
